import React from 'react'
import PropTypes from 'prop-types'
import {graphql} from 'gatsby'

import Layout from '../../components/Layout'
import ArticleContent from './components/ArticleContent'
import ArticleIntro from './components/ArticleIntro'
import TagsList from './components/TagsList'
import AuthorInfo from './components/AuthorInfo'
import MoreNewsSection from './components/MoreNewsSection'


const SingleNewsPage = ({data: rawData, pageContext}) => {
	const author = (rawData.allAuthorsJsonWithRelativePaths.nodes || [])[0]
	const data = rawData.allNewsJsonWithRelativePaths.nodes.map(one => ({...one, link: pageContext.link, author}))[0]
	return <Layout footerBack='gray' seo={{routeUrl: data.link, ...data.seo}}>
		<ArticleIntro data={{
			aboveTitle: data.aboveTitle,
			title: data.title,
			intro: data.intro,
			author: data.author,
			createdAt: data.createdAt,
		}}/>
		<ArticleContent data={data.content}/>
		<TagsList data={data.tags}/>
		<AuthorInfo data={data.author}/>
		<MoreNewsSection currentSlug={data.slug}/>
	</Layout>
}

export const query = graphql`
query ($slug: String, $authorName: String) {
  allNewsJsonWithRelativePaths(filter: {slug: {eq: $slug}}) {
    nodes {
      createdAt
      excerpt
      slug
      author
      intro
      title
      aboveTitle
      tags
      content {
        textMd
        image {
          caption
          image {
            childImageSharp {
              fluid(maxWidth: 800) {
				  ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      seo {
        title
        description
        author
        metaImage {
          publicURL
        }
      }
    }
  }
  
  allAuthorsJsonWithRelativePaths(filter: {name: {eq: $authorName}}) {
    nodes {
    	name
    	position
    	company
    	about
    	socials {
    		linkedin
    		twitter
    	}
    	about
    	photo {
		  childImageSharp {
			fixed(width: 200, height: 150, cropFocus: NORTH) {
				...GatsbyImageSharpFixed
			}
		  }
    	}
    }
  }
}

`


SingleNewsPage.propTypes = {
	data: PropTypes.any.isRequired,
	pageContext: PropTypes.shape({
		link: PropTypes.string.isRequired,
		// title: PropTypes.string.isRequired,
		// createdAt: PropTypes.string.isRequired,
		// aboveTitle: PropTypes.string.isRequired,
		// excerpt: PropTypes.string.isRequired,
		// author: PropTypes.string.isRequired,
		// intro: PropTypes.string.isRequired,
		// tags: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
		// content: PropTypes.arrayOf(PropTypes.shape({
		// 	textMd: PropTypes.string.isRequired,
		// 	image: PropTypes.shape({
		// 		caption: PropTypes.string.isRequired,
		// 		image: imageType,
		// 	}).isRequired,
		// }).isRequired).isRequired,
		// seo: PropTypes.shape({
		// 	title: PropTypes.string.isRequired,
		// 	description: PropTypes.string.isRequired,
		// 	author: PropTypes.string.isRequired,
		// 	metaImage: PropTypes.shape({
		// 		publicURL: PropTypes.string.isRequired,
		// 	}).isRequired,
		// }).isRequired,
	}).isRequired,
}


export default SingleNewsPage
